// IMAGE GALLERY SECTION
class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {


    if (this.querySelectorAll(`.swiper-slide`)) {
      this.querySelectorAll(`.gallery-top`).forEach((item) => {
        const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
          direction: item.dataset.direction,
          slidesPerView: 5,
          spaceBetween: 0,
          mousewheel: false,
          grabCursor: false,
          freeMode: false,
          allowTouchMove: false,
          breakpoints: {
            0: {
              spaceBetween: 0,
              direction: 'horizontal',
              slidesPerView: 5
            },
            490: {
              spaceBetween: 0,
              direction: 'horizontal',
              slidesPerView: 8
            },
            768: {
              spaceBetween: 0,
              slidesPerView: 5,
              direction: item.dataset.direction,
            }
          }
        });
        const sliderImages = new Swiper(item, {
          direction: item.dataset.direction,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 1000,
          mousewheel: false,
          grabCursor: false,
          allowTouchMove: false,
          thumbs: {
            swiper: sliderThumbs
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true
          },
          breakpoints: {
            0: {
              direction: 'horizontal',
              mousewheel: false,
              allowTouchMove: true,
              speed: 100,
            },
            769: {
              direction: item.dataset.direction,
              allowTouchMove: false,
              speed: 0,
            },
          }
        });

        const event = new Event('productJsLoaded');
        window.dispatchEvent(event);
      });
    }


    //show all thumbnails

    if(this.querySelectorAll('.js-show-allthumbs').length > 0){
      this.querySelector('.js-show-allthumbs').addEventListener('click', (e) => {
        e.preventDefault();
        this.querySelector('.product-thumbnail .swiper-wrapper').style.flexWrap = 'wrap';
        e.currentTarget.style.display = 'none';
      })
    }


    //jQuery

      //Product image popup
      $('.js-zoom-image').magnificPopup({
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {

        },
        callbacks: {

          resize: function(){
            let heightLoadImg = this.content.find('img').height()
            this.content.find('img').addClass('smallSize')
            this.content.find('img').on('click', function(){
              if($(this).hasClass('smallSize')){
                $(this).css('max-height', '100%');
                $(this).removeClass('smallSize')
              }else{
                $(this).css('max-height', heightLoadImg);
                $(this).addClass('smallSize')
              }
            })

          },
          imageLoadComplete: function(){
            this.content.find('img').css('width', 'auto');
          },
          change:function(){
            this.content.find('img').css('max-width', 'auto');
          },
        }
      });
      //Product gallery popup
      $('.js-zoom-gallery').magnificPopup({
        type: 'image',
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: 'auto',
        removalDelay: 0, //delay removal by X to allow out-animation
        callbacks: {
          beforeOpen: function() {
            // just a hack that adds mfp-anim class to markup
            this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
            this.st.mainClass = 'mfp-zoom-in';
            setTimeout(function(){
              if(document.querySelectorAll('.mfp-arrow-left').length > 0){
                document.querySelector('.mfp-arrow-left').innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chleft"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg>
                `;
                document.querySelector('.mfp-arrow-right').innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chright"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg>
                `;
              }
            },0)

          },
          change: function() {

          }
        },
        closeBtnInside: true,
        preloader: false,

        midClick: true,
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        },
      });
      //replace gallery nav icons



  }
}

window.addEventListener('load', () => {
  customElements.define('product-gallery', ProductGallery);



});


//recently viewed localstorage urls array
function updateVisitedUrlsLimited(currentUrl, limit = 10) {
  const storageKey = 'visitedUrls';
  let urls = JSON.parse(localStorage.getItem(storageKey)) || [];
  
  if(currentUrl.includes('products')){
    urls = urls.filter((url) => url !== currentUrl);

    urls.unshift(currentUrl);

    if (urls.length > limit) {
      urls.pop(); 
    }



    localStorage.setItem(storageKey, JSON.stringify(urls));
    
  }
}
updateVisitedUrlsLimited(window.location.pathname, 10);
